Postlogin = (function (my) {
    my.AdminDashboard = {};
    const self = my.AdminDashboard;

    self.init = function () {
        setTimeout(() => {
            initOnlineSchoolsTable();
        }, 1);

        setTimeout(() => {
            initOnlineUsersTable();
        }, 500);
    };

    const $userListTable = $('#user-list-table');
    const $onlineSchoolsListTable = $('#online-schools-list-table');
    const tableHeight = window.innerHeight * 0.35;

    let schoolTableActualHeight = 0;
    let userTableActualHeight = 0;

    const initOnlineUsersTable = function () {
        const userEditUrl = $userListTable.data('user-edit-url');

        $userListTable.bootstrapTable({
            formatNoMatches() {
                return 'No users online at this time.';
            },
            method: 'post',
            contentType: 'application/x-www-form-urlencoded',
            classes: 'table table-hover table-condensed',
            height: tableHeight,
            striped: true,
            showRefresh: false,
            showToggle: false,
            showColumns: false,
            showPaginationSwitch: false,
            idField: 'user_id',
            minimumCountColumns: '2',
            pagination: false,
            search: false,
            sortName: 'date_last_activity',
            sortOrder: 'desc',
            clickToSelect: false,
            maintainSelected: false,
            sidePagination: 'client',
            url: '/users/json/',
            queryParamsType: 'other',
            async: true,
            queryParams(params) {
                const myParams = {};
                myParams.page = 1;
                myParams.page_size = 10;
                myParams.order_by = params.sortName;
                myParams.sort_order = params.sortOrder;
                myParams.logged_in = 1;
                myParams.no_stats = true;

                return myParams;
            },
            columns: [
                {
                    title: 'Role',
                    field: 'role_name',
                    align: 'left',
                    valign: 'middle',
                    sortable: true,
                    formatter(value, row) {
                        let iconClass = '';
                        switch (row.role_id) {
                            case 2:
                                iconClass = 'fa-child';
                                break;
                            case 3: // teacher
                                iconClass = 'fa-user text-success';
                                break;
                            case 4: // school admin
                                iconClass = 'fa-user text-info';
                                break;
                            case 5: // district admin
                                iconClass = 'fa-user text-warning';
                                break;
                            case 6: // vjs admin
                                iconClass = 'fa-user text-danger';
                                break;
                            case 7:
                                iconClass = 'fa-laptop';
                                break;
                            default:
                                break;
                        }

                        const userRole = `<i class="fa ${iconClass}" aria-hidden="true"></i> ${value}`;

                        return userRole;
                    },
                },
                {
                    title: 'User',
                    field: 'username',
                    align: 'left',
                    valign: 'middle',
                    sortable: true,
                    formatter(value, row) {
                        const editUrl = userEditUrl.replace(':user_id', row.user_id);

                        return `<a href="${editUrl}">${value}<br /> [${row.first_name} ${row.last_name}]</a>`;
                    },
                },
                {
                    title: 'Last Login',
                    field: 'date_last_login',
                    align: 'left',
                    valign: 'middle',
                    sortable: true,
                    sorter: Jr.Utils.dateSorter,
                    formatter(value) {
                        return Jr.Utils.convertDate(value, 'llll');
                    },
                },
                {
                    title: 'Last Activity',
                    field: 'date_last_activity',
                    align: 'left',
                    valign: 'middle',
                    sortable: true,
                    sorter: Jr.Utils.dateSorter,
                    formatter(value) {
                        return Jr.Utils.convertDate(value, 'llll');
                    },
                },
                {
                    title: 'Licenses',
                    field: 'license_name',
                    align: 'left',
                    valign: 'middle',
                    sortable: true,
                },
                {
                    title: 'District',
                    field: 'district_name',
                    align: 'left',
                    valign: 'middle',
                    sortable: true,
                },
            ],
            responseHandler(res) {
                $userListTable.closest('.light-blur').removeClass('light-blur');
                $('#number_logged_in').html(res.meta.total);

                const formattedResult = {};
                formattedResult.total = res.meta.total;
                formattedResult.rows = res.data;
                formattedResult.duration = res.meta.duration;

                return formattedResult;
            },
            onLoadSuccess() {
                $('time.timeago').timeago();
                userTableActualHeight = $userListTable.outerHeight() + 2;
                if (schoolTableActualHeight > 0) {
                    $userListTable
                        .closest('.fixed-table-container')
                        .css('height', Math.max(userTableActualHeight, schoolTableActualHeight));
                    $onlineSchoolsListTable
                        .closest('.fixed-table-container')
                        .css('height', Math.max(userTableActualHeight, schoolTableActualHeight));
                }
            },
        });
    };

    const initOnlineSchoolsTable = function () {
        $onlineSchoolsListTable.bootstrapTable({
            formatNoMatches() {
                return 'No schools online at this time.';
            },
            method: 'post',
            contentType: 'application/x-www-form-urlencoded',
            classes: 'table table-hover table-condensed',
            height: tableHeight,
            striped: true,
            showRefresh: false,
            showToggle: false,
            showColumns: false,
            showPaginationSwitch: false,
            idField: 'license_id',
            minimumCountColumns: '2',
            pagination: false,
            search: false,
            sortName: 'students',
            sortOrder: 'desc',
            clickToSelect: false,
            maintainSelected: false,
            sidePagination: 'client',
            url: '/api/licenses/online/',
            pageSize: 10,
            queryParamsType: 'other',
            async: true,
            queryParams(params) {
                const myParams = {};
                myParams.page = params.pageNumber;
                myParams.page_size = params.pageSize;
                myParams.order_by = params.sortName;
                myParams.sort_order = params.sortOrder;

                return myParams;
            },
            columns: [
                {
                    title: 'District',
                    field: 'district_name',
                    align: 'left',
                    valign: 'middle',
                    sortable: true,
                },
                {
                    title: 'Licenses',
                    field: 'license_name',
                    align: 'left',
                    valign: 'middle',
                    sortable: true,
                },
                {
                    title: '<i class="fa fa-child text-success" aria-hidden="true"></i>',
                    field: 'students',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                },
                {
                    title: '<i class="fa fa-user text-danger" aria-hidden="true"></i>',
                    field: 'admins',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                },
            ],
            responseHandler(res) {
                $onlineSchoolsListTable.closest('.light-blur').removeClass('light-blur');
                const formattedResult = res.data;

                $('#number_schools_logged_in').html(res.meta.total);

                let numberLoggedIn = 0;

                $(formattedResult).each((i, row) => {
                    numberLoggedIn += row.students + row.admins;
                });

                // we can set this usually well before details of logged in users comes back!
                $('#number_logged_in').html(numberLoggedIn);

                return formattedResult;
            },
            onLoadSuccess() {
                schoolTableActualHeight = $onlineSchoolsListTable.outerHeight() + 2;
                if (userTableActualHeight > 0) {
                    $userListTable
                        .closest('.fixed-table-container')
                        .css('height', Math.max(userTableActualHeight, schoolTableActualHeight));
                    $onlineSchoolsListTable
                        .closest('.fixed-table-container')
                        .css('height', Math.max(userTableActualHeight, schoolTableActualHeight));
                }
            },
        });
    };

    return my;
}(Postlogin));
